const checkCookieExists = (cookie) => {
  // eslint-disable-next-line no-undef
  return $cookies.isKey(cookie)
}

export default checkCookieExists
